import React, { FC, useEffect, useRef } from 'react'
import Form from '@/components/Form'
import sectionLaserSettingFormItems from './../forms/sectionLaserSettingFormItems'
import { Button } from '@/components/UiElements'

interface EngravingSettingFormProps {
	settings: any | null
	onUpdateSuccess: (settings: any) => void
}


const EngravingSettingForm: FC<EngravingSettingFormProps> = ({ settings, onUpdateSuccess }) => {

	const formRef = useRef<any>(null)

	const handleSaveSettings = ()=> {
		const data = formRef.current?.getData()
		onUpdateSuccess(data)
	}

	useEffect(() => {
		formRef.current.setData(settings)
	}, [settings])

	return (
		<div className={'flex flex-col gap-xxxl'}>
			<div className={'w-[850px] grid grid-cols-12 gap-md'}>
				<Form
					ref={formRef}
					items={sectionLaserSettingFormItems}
					defaultValues={settings || {}}

				/>
			</div>
			<Button
				size="lg"
				onClick={handleSaveSettings}
			>
				{settings ? 'Update Settings' : 'Add Settings'}
			</Button>
		</div>
	)
}


export default EngravingSettingForm